import { render, staticRenderFns } from "./unloadedProduct.vue?vue&type=template&id=5a287ab7&scoped=true&"
import script from "./unloadedProduct.vue?vue&type=script&lang=js&"
export * from "./unloadedProduct.vue?vue&type=script&lang=js&"
import style0 from "./unloadedProduct.vue?vue&type=style&index=0&id=5a287ab7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a287ab7",
  null
  
)

export default component.exports